import React, {memo, type FC} from "react"
import {useTemplatedComponent, TemplateSettingsModel} from "@next/templating"
import {MANIFEST} from "@manifest/product-summary"
import {ColourwaySwiperDetailsProps} from "../ColourwaySwiperDetails"
import {SlideDetail} from "../../helpers"
import connect from "./connect"

interface ColourwaySingleSlideProps {
    slide: SlideDetail
    imageDetails: ColourwaySwiperDetailsProps
    isOnServer?: boolean
    template: TemplateSettingsModel
}

const ColourwaySingleSlide: FC<ColourwaySingleSlideProps> = memo(
    ({slide, imageDetails, template, isOnServer = false}) => {
        const ComponentName = useTemplatedComponent(template, MANIFEST)

        const props = {
            slide,
            isOnServer,
            imageDetails,
        }

        return <ComponentName {...props} />
    },
)
ColourwaySingleSlide.displayName = "ColourwaySingleSlide"

export default connect(ColourwaySingleSlide)
